import  { HANDLE_CUSTOMER, RESET } from "../actions";

const initialState = {
    customer: [],
    customerApiCalled: false,
    pageNo: 1,
    field: "",
    search: "",
    filterApplied: false,
    selectedCustomer: null,
    customerData: []
};

const customers = (state = initialState, action) => {
    switch(action.type) {
        case HANDLE_CUSTOMER : 
            return {
                ...state,
                ...action.data
            }
        case RESET :
            return initialState
        default:
            return state;
    }
}

export default customers;